// src/Store/GlobalStateStore.ts
import { defineStore } from 'pinia';

export enum Enum_CurrentPage {
    MainPage,
}

export enum Enum_Theme {
    Dark,
    Light,
}

export const useGlobalStateStore = defineStore('GlobalState', {
    state: () => ({
        CurrentPage: Enum_CurrentPage.MainPage, // 当前页面
        CurrentTheme: Enum_Theme.Dark, // 当前主题
        CurrentSection: 0, // 当前所在的全屏段落 (0:首页, 1:产品, 2:新闻, 3:了解我们, 4:加入我们)
    }),
    actions: {
        SetCurrentPage(NewPage: Enum_CurrentPage) {
            this.CurrentPage = NewPage;
        },
        SetCurrentTheme(NewTheme: Enum_Theme) {
            this.CurrentTheme = NewTheme;
        },
        SetCurrentSection(SectionIndex: number) {
            this.CurrentSection = SectionIndex;
        }
    },
});

export default useGlobalStateStore;
